import styled from 'styled-components'

import FormikTextField from 'components/TextFieldFormik'
import { useTranslation } from 'react-i18next'

import TextareaFormik from 'components/TextareaFormik'

import { useGetAccountSubnetApiServices } from 'services/subnetApiService/useAccountSubnetApiService'
import { useGetSubnetApiServices } from 'services/subnetApiService/useSubnetApiService'
import { useEffect } from 'react'
import { ButtonTertiary } from 'components/Button/Button'
import DropdownFormik from 'components/DropdownFormik'

type ApiKeyFormProps = {
    formik: any
    isLoading?: boolean
    isEdit?: boolean
    subnetId?: string
}

const ApiKeysForm = ({ formik, subnetId }: ApiKeyFormProps) => {
    const { t } = useTranslation()

    const { values, setFieldValue } = formik
    const { description } = values

    const { data: subnet_api_services, refetch: subnetApiRefetch } = useGetSubnetApiServices(
        subnetId || '',
    )
    const { data: account_subnets, refetch: accountSubnetRefetch } =
        useGetAccountSubnetApiServices()

    const matchingItems = subnet_api_services?.filter(subnetItem =>
        account_subnets?.some(
            (account_subnet: { subnet_api_service_id: string }) =>
                account_subnet.subnet_api_service_id === subnetItem.id,
        ),
    )

    const options = matchingItems?.map(item => {
        return { label: item.name, value: item.id }
    })

    useEffect(() => {
        if (subnetId) {
            subnetApiRefetch()
            accountSubnetRefetch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSelectAll = () => {
        const allOptionValues = options?.map(option => option.value) || []
        setFieldValue('account_subnet_ids', allOptionValues)
    }

    const hideDropdown = true

    return (
        <StyledInputWrapper>
            <FormikTextField name='name' placeholder={t('name')} label={t('name')} />
            <TextareaFormik
                setFieldValue={setFieldValue}
                label={t('description')}
                fieldName={'description'}
                value={description}
            />

            {!hideDropdown && subnetId && (
                <StyledDropdownWrapper>
                    <DropdownFormik
                        label='Subnet APIs'
                        fieldName={'account_subnet_ids'}
                        fieldValue={values?.account_subnet_ids}
                        options={options}
                        setFieldValue={setFieldValue}
                        isMulti
                    />
                    <StyledButtonWrapper>
                        <ButtonTertiary onClick={handleSelectAll} size='small'>
                            Select All
                        </ButtonTertiary>
                    </StyledButtonWrapper>
                </StyledDropdownWrapper>
            )}
        </StyledInputWrapper>
    )
}

export default ApiKeysForm

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;

    gap: 20px;
    width: 100%;

    padding-bottom: 10px;
`
const StyledDropdownWrapper = styled.div`
    position: relative;
`
const StyledButtonWrapper = styled.div`
    position: absolute;
    top: -2px;
    left: 100px;
`
